import { inject } from '@angular/core'
import { provideAppInitializer } from '@angular/core'
import { Auth } from '@angular/fire/auth'

import { onAuthStateChanged } from 'firebase/auth'

import { environment } from '@coty/env/environment'

import { AuthService } from './auth.service'
import { AuthStore } from './auth.store'

/**
 * Provides an application initializer for authentication setup.
 *
 * This function sets up the authentication process by injecting the necessary
 * dependencies (`Auth` and `AuthStore`), configuring the tenant ID, and
 * listening for authentication state changes. Once the authentication state
 * is determined, it resolves the initialization process.
 *
 * @returns A function that initializes the authentication process and returns
 * a promise that resolves once the authentication state is set.
 */
export const provideAuthInitializer = () => {
  return provideAppInitializer(() => {
    const auth = inject(Auth)
    const authService = inject(AuthService)
    const authStore = inject(AuthStore)

    auth.tenantId = environment.tenantId

    return new Promise<void>((resolve) => {
      onAuthStateChanged(auth, (firebaseUser) => {
        if (firebaseUser && !authStore.getIsLoggingIn()) {
          authService.loginToYoshuApi(firebaseUser).subscribe(() => resolve())
        } else {
          resolve()
        }
      })
    })
  })
}
